<template>
    <qd-taginput
      type='is-primary'
      icon="magnify"
      v-model="critereRecherche[attribut]"
      :data="villesFiltered"
      :loading="isFetching"
      :open-on-focus="true"
      autocomplete
      :allow-new="true"
      @typing="getVilles"
      >
  </qd-taginput>
</template>

<script>

import getAllVilles from '@/services/ville/getAllVilles';
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';

export default {
  props: {
    tableName: {
      type: String,
      required: true,
    },
    critereRecherche: {
      type: Object,
      required: true,
    },
    attribut: {
      type: String,
      required: false,
      default: 'villes',
    },
  },
  data() {
    return {
      villesAutocomplete: [],
      isFetching: false,
    };
  },
  computed: {
    villesFiltered() {
      return this.villesAutocomplete
        .filter(ville => !this.critereRecherche[this.attribut].includes(ville));
    },
  },
  methods: {
    getVilles: debounce(async function getVilles(villeName) {
      try {
        this.villesAutocomplete = [];
        this.isFetching = true;

        this.villesAutocomplete = await getAllVilles(villeName, this.tableName);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetching = false;
      }
    }, 300),
  },
  mounted() {
    if (!this.critereRecherche[this.attribut]) this.critereRecherche[this.attribut] = [];
  },
};
</script>
